import { useMemo } from "react";
import _ from "lodash";
import useVademecum from "../../../medicine/vademecum/hooks/useVademecum";
import { recurringFrequencyOptions, unitsByRegNo } from "../frequencyOptions";

const useFrequencyOptions = (medicines) => {
  const vademecum = useVademecum();
  const presentationUnits = useMemo(() => unitsByRegNo(vademecum), [vademecum]);
  const options = useMemo(
    () => recurringFrequencyOptions(medicines, presentationUnits),
    [medicines, presentationUnits]
  );
  return { options, isVademecumLoaded: !_.isEmpty(vademecum) };
};

export default useFrequencyOptions;
